<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>前台配置</a-breadcrumb-item>
    <a-breadcrumb-item>充值解锁相关</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 列表 -->
  <a-table class="table-view" :data-source="dataSource" :columns="columns" :row-key="record => record.id"
    :loading="isLoading" :pagination="false">
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <!-- 编辑 -->
        <a-button type="link" @click="touchEdit(record)">
          编辑
        </a-button>
      </template>
    </template>
  </a-table>
  <!-- 虚拟币编辑 -->
  <RechargeCoin ref="RefRechargeCoin" @success="getList"></RechargeCoin>
  <!-- 会员编辑 -->
  <RechargeVip ref="RefRechargeVip" @success="getList"></RechargeVip>
  <!-- 说明编辑 -->
  <RechargeDesc ref="RefRechargeDesc" @success="getList"></RechargeDesc>
  <!-- 广告解锁剧集 -->
  <UnlockAd ref="RefUnlockAd" @success="getList"></UnlockAd>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import { FrontSource } from '@/utils/constantList'
import { message } from 'ant-design-vue'
import RechargeCoin from './components-rechargeunlock/RechargeCoin'
import RechargeVip from './components-rechargeunlock/RechargeVip'
import RechargeDesc from './components-rechargeunlock/RechargeDesc'
import UnlockAd from './components-rechargeunlock/UnlockAd'
import { cashRechargeList, frontBannerList, frontBannerSort, frontBannerDelete } from '@/api/appfront'

// 新增、编辑组件实例
let RefRechargeCoin = ref(null)
let RefRechargeVip = ref(null)
let RefRechargeDesc = ref(null)
let RefUnlockAd = ref(null)
// source类型
const source = FrontSource.banner
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 列数据源（付费转化率、权重本期不做）
let columns = ref([
  {
    title: '模块',
    dataIndex: 'desc',
    key: 'desc'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount(() => {
  // 获取配置列表
  getList()
})

// 获取配置列表
function getList() {
  isLoading.value = true
  cashRechargeList({
    source: 'banner',
    id: 1
  }).then(res => {
    // console.log(res);

    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      dataSource.value = data
    } else {
      message.error(res.message || msg)
    }
  })
}

// 编辑
function touchEdit(record) {
  if (record.type === 'vip') {
    RefRechargeVip.value.showDrawer(record ? record.id : undefined)
  } else if (record.type === 'coin') {
    RefRechargeCoin.value.showDrawer(record ? record.id : undefined)
  } else if (record.type === 'recharge') {
    RefRechargeDesc.value.showDrawer(record)
  } else if (record.type === 'ad') {
    RefUnlockAd.value.showDrawer(record)
  }
}

</script>

<style lang="less" scoped>
.tool-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 20px;
}

.cover-img {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.ant-btn-link {
  padding: 0;
  margin-left: 8px;
}
</style>